"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Model_1 = require("../Model");
const ModularScale_1 = require("../ModularScale/ModularScale");
const Number_1 = require("@pups/utility/build/Number");
class Typography extends Model_1.default {
    /**
     * Crea una istanza della classe Typography.
     * Se le grandezze (fontSize, lineHeight, lineWidth) non sono settate,
     * la grandezza di base della font sarà il valoer di rootBase del ModularScale
     *
     * @param {ModularScale} [modularScale]
     * @param {string} [fontSize]
     * @param {(string | number)} [lineHeight]
     * @param {string} [lineWidth]
     * @memberof Typography
     */
    constructor(modularScale, fontSize, lineHeight, lineWidth) {
        super();
        /**
         * Proprietà da esportare nel file di configuratione
         *
         * @type {Array<string>}
         * @memberof Typography
         */
        this.exportableProperties = ['fontSize', 'lineHeight', 'lineWidth'];
        this.modularScale = modularScale || new ModularScale_1.default();
        const properties = this.getFontProperties(fontSize, lineHeight, lineWidth);
        this.fontSize = properties.fontSize;
        this.lineHeight = properties.lineHeight;
        this.lineWidth = properties.lineWidth;
    }
    /**
     * Ritorna il riferimento alla classe ModularScale
     *
     * @readonly
     * @private
     * @type {ModularScale}
     * @memberof Typography
     */
    get ms() {
        return this.modularScale;
    }
    /**
     *
     *
     * @returns {string}
     * @memberof Typography
     */
    getFontSize() {
        return this.fontSize;
    }
    /**
     *
     *
     * @returns {(string | number)}
     * @memberof Typography
     */
    getLineHeight() {
        return this.lineHeight;
    }
    /**
     *
     *
     * @returns {string}
     * @memberof Typography
     */
    getLineWidth() {
        return this.lineWidth;
    }
    // ============================================================
    /**
     *
     *
     * @param {string} lineWidth
     * @returns {string}
     * @memberof Typography
     */
    getFontSizeFromLineWidth(lineWidth) {
        let lineWidthUnit = ModularScale_1.default.getUnitFromString(lineWidth);
        lineWidth = this.modularScale.valueToUnit(lineWidth, 'px');
        return this.modularScale.valueToUnit((Math.sqrt(Number_1.fix(lineWidth)) / this.modularScale.getRatio()) + 'px', lineWidthUnit);
    }
    /**
     *
     *
     * @param {string} fontSize
     * @param {string} lineWidth
     * @returns {string}
     * @memberof Typography
     */
    getLineHeightFromFontSizeAndLineWidth(fontSize, lineWidth) {
        let fontUnit = ModularScale_1.default.getUnitFromString(fontSize);
        fontSize = this.modularScale.valueToUnit(fontSize, 'px');
        lineWidth = this.modularScale.valueToUnit(lineWidth, 'px');
        const h = this.modularScale.getRatio() - (1 / (2 * this.modularScale.getRatio())) * (1 - (Number_1.fix(lineWidth) / Math.pow(Number_1.fix(fontSize) * this.ms.getRatio(), 2)));
        return this.modularScale.valueToUnit((Number_1.fix(fontSize) * h) + 'px', fontUnit);
    }
    /**
     *
     *
     * @param {string} fontSize
     * @param {(string | number)} lineHeight
     * @returns {string}
     * @memberof Typography
     */
    getLineWidthFromFontSizeAndLineHeight(fontSize, lineHeight) {
        let fontUnit = ModularScale_1.default.getUnitFromString(fontSize);
        fontSize = this.modularScale.valueToUnit(fontSize, 'px');
        lineHeight = this.modularScale.valueToUnit(lineHeight + '', 'px');
        return this.modularScale.valueToUnit((Math.pow(Number_1.fix(fontSize) * this.modularScale.getRatio(), 2) * (1 + 2 * this.modularScale.getRatio() * ((Number_1.fix(lineHeight) / Number_1.fix(fontSize)) - this.modularScale.getRatio()))) + 'px', fontUnit);
    }
    /**
     *
     *
     * @param {string} [fontSize]
     * @param {(string | number)} [lineHeight]
     * @param {string} [lineWidth]
     * @returns {Types.Typography.FontProperties}
     * @memberof Typography
     */
    getFontProperties(fontSize, lineHeight, lineWidth) {
        fontSize = fontSize ? fontSize : this.modularScale.getBase() + this.modularScale.getUnit();
        let fontUnit = ModularScale_1.default.getUnitFromString(fontSize);
        let lineHeightUnit;
        let lineWidthUnit;
        fontSize = this.modularScale.valueToUnit(fontSize, 'px');
        if (!lineHeight && !lineWidth) {
            lineHeightUnit = lineWidthUnit = fontUnit;
            lineHeight = (Number_1.fix(fontSize) * this.modularScale.getRatio()) + 'px';
            lineWidth = Math.pow(Number_1.fix(lineHeight), 2) + 'px';
        }
        else if (!lineHeight) {
            lineWidthUnit = ModularScale_1.default.getUnitFromString(lineWidth);
            lineHeightUnit = fontUnit;
            lineHeight = this.getLineHeightFromFontSizeAndLineWidth(fontSize, lineWidth);
        }
        else if (!lineWidth) {
            lineHeightUnit = ModularScale_1.default.getUnitFromString(lineHeight);
            lineWidthUnit = fontUnit;
            lineWidth = this.getLineWidthFromFontSizeAndLineHeight(fontSize, lineHeight);
        }
        else {
            lineWidthUnit = ModularScale_1.default.getUnitFromString(lineWidth);
            lineHeightUnit = ModularScale_1.default.getUnitFromString(lineHeight);
        }
        return {
            fontSize: this.modularScale.valueToUnit(fontSize, fontUnit),
            lineHeight: this.modularScale.valueToUnit(lineHeight + '', lineHeightUnit),
            lineWidth: this.modularScale.valueToUnit(lineWidth, lineWidthUnit)
        };
    }
}
exports.default = Typography;
//# sourceMappingURL=Typography.js.map